import React from 'react';
import Skeleton from '@mui/material/Skeleton';

function SkeletonFilter(props) {
    return (
        <>
        <Skeleton variant="rectangular" height={32} width={120} />
        <Skeleton variant="rectangular" height={250} width={240} sx={{mt: 2}} />

        <Skeleton variant="rectangular" height={32} width={120} sx={{mt: 1}} />
        <div style={{ display: 'flex',justifyContent: 'space-between'}} >
        <Skeleton variant="rectangular" height={56} width={109} sx={{mt: 1}}/>
        <Skeleton variant="rectangular" height={56} width={109} sx={{mt: 1}}/>
        </div>
        <Skeleton variant="text" sx={{ fontSize: '1rem',mt: 2 }} />

        <Skeleton variant="rectangular" height={32} width={120} sx={{mt: 1}} />
        <div style={{ display: 'flex',justifyContent: 'space-between'}} >
        <Skeleton variant="rectangular" height={56} width={109} sx={{mt: 1}}/>
        <Skeleton variant="rectangular" height={56} width={109} sx={{mt: 1}}/>
        </div>
        <Skeleton variant="text" sx={{ fontSize: '1rem',mt: 2 }} />


        <Skeleton variant="rectangular" height={32} width={120} sx={{mt: 2}}/>
        <Skeleton variant="rectangular" height={250} width={240} sx={{mt: 2}} />

        <Skeleton variant="rectangular" height={32} width={120} sx={{mt: 2}}/>
        <Skeleton variant="rectangular" height={250} width={240} sx={{mt: 2}} />
        <Skeleton variant="rectangular" height={32} width={120} sx={{mt: 2}}/>
        <Skeleton variant="rectangular" height={250} width={240} sx={{mt: 2}} />

        <Skeleton variant="rectangular" height={32} width={120} sx={{mt: 2}}/>
        <Skeleton variant="rectangular" height={250} width={240} sx={{mt: 2}} />
        <Skeleton variant="rectangular" height={32} width={120} sx={{mt: 2}}/>
        <Skeleton variant="rectangular" height={250} width={240} sx={{mt: 2}} />

        <Skeleton variant="rectangular" height={32} width={120} sx={{mt: 2}}/>
        <Skeleton variant="rectangular" height={250} width={240} sx={{mt: 2}} />
        </>
    )
}

export default SkeletonFilter;
